import {Component} from "@angular/core";
import {Field} from "../models/field.model";

@Component({
	selector: "tig-form-hidden",
	template: `
    <div
      class="form-group"
      [formGroup]="OBJ_form_group">
	  <div class="col-lg-8">
		  <input
			class="form-control"
			[(ngModel)]="OBJ_field_config.value"
			[readonly]="OBJ_field_config?.readonly"
			[formControlName]="OBJ_field_config.name"
			type="hidden" />
      </div>
    </div>
  `
})
export class FormHiddenComponent extends Field {} // end class FormHiddenComponent